import Player from '@vimeo/player';
import { IS_HIDDEN } from '/source/js/base/baseClasses';
const IS_PLAYING = 'is--playing';
const PRODUCT_VIDEO = '.product-gallery__video';
let $infiniteScroll = $('.product-gallery').attr('data-infinite-scroll');
let prevIcon = "<button type='button' class='slick-prev slick-arrow slick-btn slick-btn--left' aria-label='Previous'><img src='/assets/images/icons/ICO-left.svg' alt='' class='slick-state-active is--hidden' aria-hidden='true'/><img src='/assets/images/icons/ICO-left-disabled.svg' alt='' aria-hidden='true' class='slick-state-disabled'/></button>";
if($infiniteScroll === 'true' || $infiniteScroll === 'True') {
    prevIcon = "<button type='button' class='slick-prev slick-arrow slick-btn slick-btn--left' aria-label='Previous'><img src='/assets/images/icons/ICO-left.svg' alt='' class='slick-state-active' aria-hidden='true'/><img src='/assets/images/icons/ICO-left-disabled.svg' alt='' aria-hidden='true' class='slick-state-disabled  is--hidden'/></button>";
}
let nextIcon = "<button type='button' class='slick-next slick-arrow slick-btn slick-btn--right' aria-label='Next'><img src='/assets/images/icons/ICO-long-arrow.svg' alt='' class='slick-state-active' aria-hidden='true'/><img src='/assets/images/icons/ICO-long-arrow-disabled.svg' alt='' aria-hidden='true' class='slick-state-disabled is--hidden'/></button>";

function stopModalEvents() {
    let $this = $(this);
    if($this.hasClass('isa-modal--vimeo')) {
        let playertest = $(`.${IS_PLAYING}`);
        let vimeoPlayer = new Player(playertest);
        vimeoPlayer.pause();
        $(PRODUCT_VIDEO).removeClass(IS_PLAYING);
    }
}

function productSliders() {
    let $productGalleryMain = $('.product-gallery__main');
    let $isaModalSlider = $('.product-gallery__nav-modal');
    console.log('infiniteScroll : ', $infiniteScroll);
    if($productGalleryMain.children().length > 1) {
        $productGalleryMain.not('.slick-initialized').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: !!($infiniteScroll === 'true' || $infiniteScroll === 'True'),
            dots: true,
            asNavFor: $isaModalSlider,
            prevArrow: prevIcon,
            nextArrow: nextIcon,
            customPaging: function(slider, i) {
                let icon = $(slider.$slides[i]).data('video-icon');
                if(icon) {
                    return '<button class="slick-video-icon"><img src="' + icon + '" alt=""></button>';
                } else {
                    return '<button></button>';
                }
            },
            rows: 0,
            arrows: true
        });
    }

    $isaModalSlider.not('.slick-initialized').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        rows: 0,
        infinite: !!($infiniteScroll === 'true' || $infiniteScroll === 'True'),
        arrows: true,
        asNavFor: $productGalleryMain,
        prevArrow: prevIcon,
        nextArrow: nextIcon,
        draggable: true,
        focusOnSelect: true
    });
}

function enableZoom($slickSlideGallery) {
    $slickSlideGallery.find('.slick-slide .product-gallery__img-wrap').zoom({ on: 'click', magnify: 1.5 });
}

function showModal() {
    let $isaModalGallery = $('.isa-modal--gallery');
    let $productGalleryVideo = $('.product-gallery__video');
    $isaModalGallery.addClass('is--active');

    enableZoom($isaModalGallery);

    $productGalleryVideo.each(function () {
        let $this = $(this);

        let videoID = $this.attr('id');
        if(!videoID) {
            videoID = $this.parent().attr('id');
        }

        let src = $this.attr('src');
        if($this.hasClass('product-gallery__video--youtube')) {
            if(!src.length) {
                $this.attr('src', `https://www.youtube.com/embed/${videoID}?controls=1`);
            }
        } else {
            if(!src.length) {
                $this.attr('src', `https://player.vimeo.com/video/${videoID}?embedparameter=value`);
            }
        }
    });
}

function closeModal() {
    let $isaModalGallery = $('.isa-modal--gallery');
    let $productGalleryVideo = $('.product-gallery__video');
    $isaModalGallery.removeClass('is--active');
    $productGalleryVideo.attr('src', '');
}

function disableBtn() {
    let $this = $(this);
    let closestDiv = $this.closest('.product-gallery__main');
    let closestDivModal = $this.closest('.product-gallery__nav-modal');
    let isLeftIcon = $this.hasClass('slick-btn--left');
    if(closestDiv.length === 1 || closestDivModal.length === 1) {
        let directionStr = '.slick-btn.slick-btn--right';
        let parentDiv = '.product-gallery__nav-modal';
        if(isLeftIcon) {
            directionStr = '.slick-btn.slick-btn--left';
        }
        if(closestDivModal.length === 1) {
            parentDiv = '.product-gallery__main';
        }
        let modalButton = $(parentDiv).find(directionStr);
        normalGalleryCarousel($this);
        normalGalleryCarousel(modalButton);
    }
}

function normalGalleryCarousel($this) {
    $this.siblings('.slick-btn').children('.slick-state-active').removeClass(IS_HIDDEN);
    $this.siblings('.slick-btn').children('.slick-state-disabled').addClass(IS_HIDDEN);
    if($this.hasClass('slick-disabled')) {
        $this.children('.slick-state-active').addClass(IS_HIDDEN);
        $this.children('.slick-state-disabled').removeClass(IS_HIDDEN);
    } else {
        $this.children('.slick-state-active').removeClass(IS_HIDDEN);
        $this.children('.slick-state-disabled').addClass(IS_HIDDEN);
    }
}

function initEventHandlers() {
    let $body = $('body');
    let $isaModalGallery = $('.isa-modal--gallery');
    let $productGalleryBtn = $('.product-gallery__btn');
    let $isaModalClose = $('.isa-modal__close');

    $isaModalGallery.on('hidden.bs.modal', stopModalEvents);
    productSliders();
    $productGalleryBtn.on('click', showModal);
    $isaModalClose.on('click', closeModal);
    $('.slick-btn').on('click', disableBtn);

    $body.on('click', '.product__select input,.product__related-group-list input', function() {
        let $isaModalGallery = $('.isa-modal--gallery');
        let $productGalleryBtn = $('.product-gallery__btn');
        let $isaModalClose = $('.isa-modal__close');
        $isaModalGallery.on('hidden.bs.modal', stopModalEvents);
        productSliders();
        $productGalleryBtn.on('click', showModal);
        $isaModalClose.on('click', closeModal);
        $('.slick-btn').on('click', disableBtn);
    });
}

$(function () {
    initEventHandlers();
});
